import { DocumentStatus } from '@/schema'

import { EditorModeType } from './types'

export const DOCUMENT_STATUS_DISPLAY_TEXT = {
  [DocumentStatus.NEW]: 'New',
  [DocumentStatus.IN_REVIEW]: 'In Review',
  [DocumentStatus.QUERY_RAISED]: 'Query Raised',
  [DocumentStatus.UNDER_REVISION]: 'Under Revision',
  [DocumentStatus.APPROVED]: 'Approved',
}

export const COMMENT_STATUS_STYLES: Record<
  'open' | 'resolved',
  { bg: string; text: string; border: string }
> = {
  open: { bg: 'bg-blue-50', text: 'text-blue-600', border: 'border-blue-200' },
  resolved: {
    bg: 'bg-green-50',
    text: 'text-green-600',
    border: 'border-success-200',
  },
}

export enum EditorMode {
  PLAIN = 'plain',
  MARKDOWN = 'markdown',
}

export enum ECommentStatus {
  OPEN = 'open',
  RESOLVED = 'resolved',
}

/**
 * Regex patterns for mention markdown format: @[username](user:userId)
 */

/**
 * Pattern to match mention at the end of a string (for validation)
 * Used to check if text ends with a mention pattern
 * Example: "Hello @[john](user:123)" → matches
 * Example: "Hello @[john](user:123) world" → doesn't match
 */
export const MENTION_PATTERN_END_REGEX = /@\[[^\]]+\]\(user:[^)]+\)$/

/**
 * Pattern to match mention anywhere in string with capture groups (for extraction)
 * Captures: [1] = username, [2] = userId
 * Global flag allows finding all mentions in a string
 * Example: "Hello @[john](user:123) and @[jane](user:456)"
 *   → matches twice, capturing "john"/"123" and "jane"/"456"
 */
export const MENTION_PATTERN_WITH_CAPTURE_REGEX =
  /@\[([^\]]+)\]\(user:([^)]+)\)/g

/**
 * Pattern to match mention anywhere in string (for detection)
 * No capture groups, no end anchor - just checks if mention exists
 * Example: "Hello @[john](user:123) world" → matches
 */
export const MENTION_PATTERN_REGEX = /@\[[^\]]+\]\(user:[^)]+\)/

export const DEFAULT_EDITOR_ID = 'rich-text-editor'
export const REPLY_EDITOR_ID = 'thread-reply-editor'
export const DEFAULT_MODE: EditorModeType = EditorMode.PLAIN
